import React from 'react';
import { Box, Button, Flex, Skeleton, Text } from '@chakra-ui/react';
import { Cartridge } from '../../../../components/GamesList/cartridge';
import { ethers } from 'ethers';
import { useNavigate } from 'react-router-dom';
import { Platform } from 'src/components/GamesList/platform';
import { IContent as IFeaturedContent } from '../featured';
import { formatUsd, trimAddress } from '../../../../utils/parser';
import { useTranslation } from 'react-i18next';
import { isNull } from 'src/lib/Hashup/util';

interface IContent {
	data: IFeaturedContent;
	isLoading?: boolean;
}

export const Content = ({ data, isLoading }: IContent) => {
	const history = useNavigate();

	const handleGoToGameProfile = () => {
		history(`/game/${data.game.address}`);
	};

	const { t } = useTranslation();

	return (
		<Flex
			color="textAction"
			gridGap={{ base: '8px', hashup: '16px' }}
			flexDirection="column"
		>
			{/* <Cartridge
					type={game.colors}
					fontWeight="400"
					fontSize="16px"
					lineHeight="20px"
					borderRadius="3px"
					padding="2px 8px"
				/> */}
			<Flex flexDirection="column">
				<Flex
					fontWeight="700"
					fontSize={{ base: '12px', hashup: '14px' }}
					lineHeight={{ base: '15px', hashup: '18px' }}
				>
					{isLoading ? (
						<Skeleton
							h={{ base: '15px', hashup: '18px' }}
							w="7vw"
						/>
					) : ethers.utils.isAddress(data.game.creator) ? (
						trimAddress(data.game.creator)
					) : (
						data.game.creator
					)}
				</Flex>
				<Box
					fontWeight="700"
					fontSize={{ base: '40px', hashup: '50px' }}
					lineHeight={{ base: '50px', hashup: '64px' }}
					cursor="pointer"
					onClick={handleGoToGameProfile}
				>
					{isLoading ? (
						<Skeleton
							mt="5px"
							h={{ base: '40px', hashup: '54px' }}
							w="20vw"
						/>
					) : (
						<Text>{data.game.name}</Text>
					)}
				</Box>
			</Flex>

			<Box
				fontWeight="400"
				fontSize="14px"
				lineHeight="140%"
				color="#e5e5e5"
				maxWidth="26em"
				display={{ base: 'none', hashup: 'block' }}
			>
				{isLoading ? (
					<Skeleton
						h="8vh"
						w="23vw"
					/>
				) : (
					<Text>
							{data.description || data.game.description}
						</Text>
				)}
			</Box>
			<Flex gridGap="16px">
				{isLoading ? (
					<Skeleton
						h="4vh"
						w="6vw"
					/>
				) : (
					<>
						<Cartridge
							type={data.game.color}
							fontWeight="400"
							fontSize="16px"
							lineHeight="20px"
							borderRadius="3px"
							padding="2px 8px"
						/>
						<Platform
							isGray
							data={data.game.platforms}
						/>
					</>
				)}
			</Flex>
			<Flex
				alignItems="center"
				gridGap="23px"
				mt={{ base: '8px', hashup: '0' }}
			>
				<Button
					onClick={handleGoToGameProfile}
					fontWeight="600"
					fontSize="14px"
					lineHeight="18px"
					_hover={{ background: 'action' }}
					marginTop={{ base: '0', hashup: '8px' }}
					p="10px 25px"
				>
					{t('airdrop.leftColumn.tokenInfo.readMore')}
				</Button>
				<Flex
					alignItems="center"
					gridGap=".5em"
				>
					<Text
						fontWeight="500"
						fontSize="30px"
					>
						{!isNull(data.game.address) ? formatUsd(ethers.utils.formatUnits(data.game.price, 4)) : '$…'}
					</Text>
					{data.discount && (
						<Text
							fontWeight="300"
							fontSize="20px"
							color="#C0C0C0"
							textDecoration="line-through"
							filter="drop-shadow(0px 9px 12px black)"
						>
							{formatUsd(ethers.utils.formatUnits(data.discount, 4))}
						</Text>
					)}
				</Flex>
			</Flex>
		</Flex>
	);
};
